@if (shouldShowLayout()) {
	<app-layout></app-layout>
}
@if (!shouldShowLayout()) {
	<router-outlet></router-outlet>
}
